<template>
  <v-row dense>
    <v-col>
      <v-row dense>
        <v-col cols="6">
          <v-combobox
            v-model="preset"
            outlined
            dense
            label="Facilitadores"
            :items="orderedGuidancePresets"
            item-text="name"
            hide-details
            @change="(e) => concatPreset(lodash.get(e, 'description', ''))"
            background-color="white"
            :disabled="disabled"
          />
        </v-col>

        <v-col>
          <v-combobox
            v-model="preset"
            outlined
            dense
            label="Intervalo"
            :items="prescriptionFrequencies"
            item-text="name"
            hide-details
            @change="(e) => concatPreset(lodash.get(e, 'name', ''))"
            background-color="white"
            :disabled="disabled"
          />
        </v-col>

        <v-col>
          <v-combobox
            v-model="preset"
            outlined
            dense
            label="Quando"
            :items="prescriptionPeriods"
            item-text="name"
            hide-details
            @change="(e) => concatPreset(lodash.get(e, 'name', ''))"
            background-color="white"
            :disabled="disabled"
          />
        </v-col>

        <v-col>
          <v-combobox
            v-model="preset"
            outlined
            dense
            label="Período"
            :items="prescriptionHowLongs"
            item-text="name"
            hide-details
            @change="(e) => concatPreset(lodash.get(e, 'name', ''))"
            background-color="white"
            :disabled="disabled"
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12">
          <v-textarea
            v-model="description"
            outlined
            dense
            label="*Orientações"
            item-text="name"
            hide-details
            @change="debouncedSavePrescriptionGuidance"
            background-color="white"
            :disabled="disabled"
          />
        </v-col>
      </v-row>

      <!-- <v-row justify="space-between"> -->
      <!--   <v-col cols="auto" class="gray--text"> -->
      <!--     <v-btn @click="hideForm" color="gray lighten-1" dark>minimizarX</v-btn> -->
      <!--   </v-col> -->
      <!--   <v-col cols="auto"> -->
      <!--     <v-btn v-if="true" @click="addNewItem" outlined color="light-blue">incluir outra OrientaçãoX</v-btn> -->
      <!--   </v-col> -->
      <!-- </v-row> -->
    </v-col>
  </v-row>
</template>

<script>
import SAVE_PRESCRIPTION_GUIDANCE from "@/graphql/prescription/save_prescription_guidance.gql";

export default {
  name: "PrescriptionFormGuidance",
  props: {
    attendance: Object,
    prescriptionId: String,
    prescriptionGuidance: {
      type: Object,
      default: () => {
        return {
          id: "",
        };
      },
    },
    prescriptionInput: Object,
    clearFlag: String,
    refreshList: Function,
    guidancePresets: Array,
    prescriptionFrequencies: Array,
    prescriptionPeriods: Array,
    prescriptionHowLongs: Array,
    disabled: {
      type: Boolean,
      default: false,
    },
    hideForm: Function,
    addNewItem: Function,
  },

  data() {
    return {
      errors: {},
      typing: false,
      prescriptionGuidanceId: "",
      description: "",
      preset: "",
    };
  },
  watch: {
    description() {
      this.typing = true;
      this.preset = { name: "" };
      this.debouncedSavePrescriptionGuidance();
    },
    prescriptionGuidance() {
      this.loadGuidance();
    },
    clearFlag() {
      this.errors = {};
      this.typing = false;
      this.prescriptionGuidanceId = "";
      this.description = "";
    },
    prescriptionInput() {
      if (this.prescriptionGuidanceId !== "") {
        this.debouncedSavePrescriptionGuidance();
      }
    },
  },
  created: function () {
    this.loadGuidance();

    this.debouncedSavePrescriptionGuidance = this.lodash.debounce(
      this.savePrescriptionGuidance,
      2000
    );
  },
  computed: {
    orderedGuidancePresets() {
      return this.lodash.orderBy(
        this.guidancePresets,
        [
          (e) =>
            e.name
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, ""),
        ],
        ["asc"]
      );
    },
  },
  methods: {
    concatPreset(text) {
      this.description += ` ${text}`;
      this.description = this.description.trim();
    },
    loadGuidance() {
      if (this.prescriptionGuidance.id !== "") {
        this.prescriptionGuidanceId = this.prescriptionGuidance.id;

        if (!this.typing) {
          this.description = this.prescriptionGuidance.description;
        }
      }
    },

  saveAddAndRefresh() {
    this.savePrescriptionGuidance();
    this.refreshList();
    this.addNewItem();

  },
    savePrescriptionGuidance() {
      if (this.disabled) return;

      if (this.prescriptionGuidanceId === "" && this.description === "") {
        return;
      }

      this.apolloMutate({
        mutation: SAVE_PRESCRIPTION_GUIDANCE,
        variables: {
          attendanceId: this.attendance.id,
          prescriptionId: this.prescriptionId,
          prescriptionGuidanceId: this.prescriptionGuidanceId,
          description: this.description,
          prescriptionInput: this.prescriptionInput,
        },
      }).then(({ data }) => {
        this.typing = false;

        this.$emit(
          "updatePrescriptionId",
          data.savePrescriptionGuidance.prescription.id
        );
        this.prescriptionGuidanceId = data.savePrescriptionGuidance.id;
        this.$router.replace(`/prontuario/${this.attendance.id}/receituario/${data.savePrescriptionGuidance.prescription.id}`)
        this.refreshList();
        //this.addNewItem();
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
